// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_to-object.js
// module id = 567
// module chunks = 3